<!-- Dialogs -->
<ui-confirmation-dialog
    #confirmDeleteDialog
    header="components.deprecated-confirmation-dialog.header"
    primaryButtonType="danger"
    primaryButtonLabel="delete"
    secondaryButtonLabel="cancel"
>
    <p>{{ 'components.deprecated-confirmation-dialog.description' | translate }}</p>
</ui-confirmation-dialog>

<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        title="payroll.roes.recordOfEmployment"
        [subtitle]="roe.isSubmitted() ? 'ROE submitted on: ' + (roe.submittedAt | appDate) : null"
        [back]="true"
        [backRoute]="['..']"
        [contextMenu]="true"
    >
        <div
            class="buttons"
            [class.margin-top-1]="
                !roe.allowAutomaticRoeSubmissions || (roe.allowAutomaticRoeSubmissions && roe.state !== 'open')
            "
        >
            <ui-button
                *ngIf="!roe.isSubmitted() && roe.allowAutomaticRoeSubmissions && roe.state === 'open'"
                type="primary"
                (click)="onSubmit()"
                >{{ 'payroll.roes.submitRoe' | translate }}</ui-button
            >
            <ui-badge class="margin-left-2" type="{{ getStatusBadgeType(roe.state) }}">{{
                getStatusBadgeText(roe.state)
            }}</ui-badge>
        </div>

        <app-context-item
            *ngIf="roe?.state === 'open'"
            label="{{ 'payroll.roes.edit' | translate }}"
            (click)="onEdit(roe)"
        >
        </app-context-item>
        <app-context-item label="{{ 'payroll.roes.download' | translate }}" (click)="onDownload()"> </app-context-item>
        <app-context-item
            *ngIf="roe?.state === 'open'"
            label="{{ 'payroll.roes.delete' | translate }}"
            (click)="onDelete()"
        >
        </app-context-item>
    </app-header>

    <ui-banner
        style="position: relative"
        class="margin-bottom-3"
        *ngIf="roe?.state === 'open' && !roe?.allowAutomaticRoeSubmissions"
        variant="info"
    >
        <p>{{ 'payroll.roes.submitRoeToServiceCanada' | translate }}</p>
        <ui-button class="mark-as-submitted-button" type="link" (click)="onSubmit()">{{
            'payroll.roes.markAsSubmitted' | translate
        }}</ui-button>
    </ui-banner>

    <ui-banner
        class="margin-bottom-3"
        *ngIf="(roe?.state === 'pending' || roe?.state === 'processing') && roe?.allowAutomaticRoeSubmissions"
        variant="info"
    >
        <p>{{ 'payroll.roes.roeIsBeingProcessedByHumi' | translate }}</p>
    </ui-banner>
    <ui-banner
        class="margin-bottom-3"
        *ngIf="roe?.state === 'failed' && roe?.allowAutomaticRoeSubmissions"
        variant="danger"
    >
        <p>{{ 'payroll.roes.roeHasBeenRejectedByServiceCanada' | translate }}</p>
    </ui-banner>

    <div class="ui segment">
        <app-segment-header title="payroll.roes.employeeBlock"></app-segment-header>
        <form class="ui static form">
            <div class="inline field">
                <label>{{ 'payroll.roes.firstName' | translate | i18nLabel }}</label>
                {{ roe.roeEmployee?.firstName }}
            </div>
            <div class="inline field">
                <label>{{ 'payroll.roes.lastName' | translate | i18nLabel }}</label>
                {{ roe.roeEmployee?.lastName }}
            </div>
            <div class="inline field">
                <label>{{ 'payroll.roes.addressLine' | translate | i18nLabel }}</label>
                {{ roe.roeEmployee?.addressLine1 }}
            </div>
            <div class="inline field">
                <label>{{ 'payroll.roes.addressLine#136005' | translate | i18nLabel }}</label>
                {{ roe.roeEmployee?.addressLine2 }}
            </div>
            <div class="inline field">
                <label>{{ 'payroll.roes.postalCode' | translate | i18nLabel }}</label>
                {{ roe.roeEmployee?.postalCode }}
            </div>
        </form>
    </div>

    <div class="ui segment">
        <app-segment-header title="payroll.roes.roeDatesBlocks"></app-segment-header>
        <form class="ui static form">
            <div class="inline field">
                <label>{{ 'payroll.roes.firstDayWorked' | translate | i18nLabel }}</label>
                {{ roe.firstDateWorked }}
            </div>
            <div class="inline field">
                <label>{{ 'payroll.roes.lastDayOfWork' | translate | i18nLabel }}</label>
                {{ roe.lastDateForWhichPaid }}
            </div>
            <div class="inline field">
                <label>{{ 'payroll.roes.lastDayPeriodEndDate' | translate | i18nLabel }}</label>
                {{ roe.finalPayPeriodEndingDate }}
            </div>
        </form>
    </div>

    <div class="ui segment">
        <app-segment-header title="payroll.roes.companyBlocks"></app-segment-header>
        <form class="ui static form">
            <div class="inline field">
                <label>{{ 'payroll.roes.craBusinessNumber' | translate | i18nLabel }}</label>
                {{ roe.craPayrollAccount?.registrationNumber }}
            </div>
            <div class="inline field">
                <label>{{ 'payroll.roes.craPayrollAccount' | translate | i18nLabel }}</label>
                {{ roe.craPayrollAccount?.identifier }}
            </div>
            <div class="inline field">
                <label>{{ 'payroll.roes.payPeriodType' | translate | i18nLabel }}</label>
                {{ roe.payPeriodType | titlecase }}
            </div>
        </form>
    </div>

    <div class="ui segment">
        <app-segment-header title="payroll.roes.roeBlocksA"></app-segment-header>
        <form class="ui static form">
            <div class="inline field">
                <label>{{ 'payroll.roes.expectedRecall' | translate | i18nLabel }}</label>
                {{ roe.expectedRecall?.code }}
            </div>
            <div class="inline field" *ngIf="roe.recallCodeIsY()">
                <label>{{ 'payroll.roes.recallDate' | translate | i18nLabel }}</label>
                {{ roe.expectedRecall?.date }}
            </div>
            <div class="inline field">
                <label>{{ 'payroll.roes.totalInsurableHours' | translate | i18nLabel }}</label>
                {{ roe.totalInsurableHours }}
            </div>
            <div class="inline field">
                <label>{{ 'payroll.roes.reasonForIssuingRoe' | translate | i18nLabel }}</label>
                {{ roe.reasonForIssuing?.separationCode }}
            </div>
            <div class="inline field">
                <label>{{ 'payroll.roes.comments' | translate | i18nLabel }}</label>
                {{ roe.comments }}
            </div>
        </form>
    </div>

    <div class="ui segment">
        <app-segment-header title="payroll.roes.companysRoeContact"></app-segment-header>
        <form class="ui static form">
            <div class="inline field">
                <label>{{ 'payroll.roes.firstName' | translate | i18nLabel }}</label>
                {{ roe.reasonForIssuing?.contact?.firstName }}
            </div>
            <div class="inline field">
                <label>{{ 'payroll.roes.lastName' | translate | i18nLabel }}</label>
                {{ roe.reasonForIssuing?.contact?.lastName }}
            </div>
            <div class="inline field">
                <label>{{ 'payroll.roes.areaCode' | translate | i18nLabel }}</label>
                {{ roe.reasonForIssuing?.contact?.areaCode }}
            </div>
            <div class="inline field">
                <label>{{ 'payroll.roes.phoneNumber' | translate | i18nLabel }}</label>
                {{ roe.reasonForIssuing?.contact?.phoneNumber }}
            </div>
            <div class="inline field">
                <label>{{ 'payroll.roes.phoneNumberExtension' | translate | i18nLabel }}</label>
                {{ roe.reasonForIssuing?.contact?.phoneExtensionNumber }}
            </div>
        </form>
    </div>

    <div class="ui table segment">
        <app-segment-header title="payroll.roes.perperiodInsurableEarningsBlockC"></app-segment-header>
        <table class="ui table">
            <thead>
                <tr>
                    <!--<th>Number</th>-->
                    <th>{{ 'payroll.roes.startDate' | translate }}</th>
                    <th>{{ 'payroll.roes.endDate' | translate }}</th>
                    <th>{{ 'payroll.roes.amount' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let payPeriod of roe.payPeriods">
                    <!--<td>{{ payPeriod.number }}</td>-->
                    <td>{{ payPeriod.startDate }}</td>
                    <td>{{ payPeriod.endDate }}</td>
                    <td>{{ getInsurableAmountByPayPeriodNumber(payPeriod.number)?.amount | i18nNum: '$' }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="ui segment">
        <app-segment-header title="payroll.roes.vacationPayBlockA"></app-segment-header>
        <form class="ui static form">
            <!--<div class="inline field">
                <label>Number</label>
                {{ roe.vacationPay?.number }}
            </div>-->
            <div class="inline field">
                <label>{{ 'payroll.roes.code' | translate | i18nLabel }}</label>
                {{ roe.vacationPay?.code }}
            </div>
            <div class="inline field">
                <label>{{ 'payroll.roes.amount' | translate | i18nLabel }}</label>
                {{ roe.vacationPay?.amount }}
            </div>
        </form>
    </div>

    <div class="ui table segment">
        <app-segment-header title="payroll.roes.statutoryHolidayPaysBlockB"></app-segment-header>
        <table class="ui table">
            <thead>
                <tr>
                    <!--<th>Number</th>-->
                    <th>{{ 'payroll.roes.date' | translate }}</th>
                    <th>{{ 'payroll.roes.amount' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let statutoryHoliday of roe.statutoryHolidays">
                    <!--<td>{{ statutoryHoliday.number }}</td>-->
                    <td>{{ statutoryHoliday.date }}</td>
                    <td>{{ statutoryHoliday.amount }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="ui table segment">
        <app-segment-header title="payroll.roes.otherMoniesBlockC"></app-segment-header>
        <table class="ui table">
            <thead>
                <tr>
                    <!--<th>Number</th>-->
                    <th>{{ 'payroll.roes.code' | translate }}</th>
                    <th>{{ 'payroll.roes.amount' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let otherMoney of roe.otherMonies">
                    <!--<td>{{ otherMoney.number }}</td>-->
                    <td>{{ otherMoney.code }}</td>
                    <td>{{ otherMoney.amount }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="ui table segment">
        <app-segment-header title="payroll.roes.specialPaymentsBlock"></app-segment-header>
        <table class="ui table">
            <thead>
                <tr>
                    <th>{{ 'payroll.roes.code' | translate }}</th>
                    <th>{{ 'payroll.roes.amount' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let specialPayment of roe.specialPayments">
                    <td>{{ specialPayment.code }}</td>
                    <td>{{ specialPayment.amount }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
